import type { ModulePage } from './types'

// Lighter "More modules" entries. Each still resolves to a real /product/:slug
// page (the detail page renders sections conditionally), so there are no dead
// links: they're just less heavily produced than the five hero modules.

export const moreModules: ModulePage[] = [
  {
    slug: 'advisory-tools',
    name: 'Advisory & Planning Tools',
    tagline: 'Cash flow, tax planning and scenarios: the numbers behind the advice.',
    icon: 'chart',
    colorClass: 'growth',
    pricingModules: ['advisory_tools'],
    featured: false,
    seo: {
      title: 'Cash Flow & Tax Planning Tools',
      description:
        'Model cash flow, run tax planning scenarios and bring portfolios into your advice: the planning tools advisers need, built into WealthSpace.',
      keywords: 'cash flow planning software, tax planning IFA, financial planning scenarios',
    },
    hero: {
      eyebrow: 'Advisory & Planning Tools',
      title: 'The numbers behind',
      titleAccent: 'the advice',
      subtitle:
        'Cash flow modelling, tax planning and scenario tools that turn a conversation about goals into a plan you can stand behind.',
    },
    benefits: [
      { icon: 'chart', title: 'Cash flow planning', body: 'Model a client’s financial future and show the impact of decisions visually.' },
      { icon: 'sparkle', title: 'Tax planning & scenarios', body: 'Run and compare scenarios to find the most tax-efficient route to the goal.' },
      { icon: 'users', title: 'Portfolios & investments', body: 'Bring holdings and valuations into the plan so advice and assets stay aligned.' },
    ],
  },
  {
    slug: 'knowledge-base',
    name: 'Knowledge Base & RAG',
    tagline: 'Your firm’s knowledge, instantly searchable and AI-ready.',
    icon: 'knowledge',
    colorClass: 'referral',
    pricingModules: ['knowledge_base'],
    featured: false,
    seo: {
      title: 'Knowledge Base & RAG',
      description:
        'Centralise your firm’s documents, policies and research into a searchable knowledge base that grounds the AI in your own expertise.',
      keywords: 'adviser knowledge base, RAG financial advice, firm document search',
    },
    hero: {
      eyebrow: 'Knowledge Base & RAG',
      title: 'Your firm’s knowledge,',
      titleAccent: 'on tap',
      subtitle:
        'Centralise policies, research and documents into one searchable knowledge base, and use it to ground Sparks and AI reports in your own expertise.',
    },
    benefits: [
      { icon: 'knowledge', title: 'One searchable library', body: 'Policies, research and guidance in one place, findable in seconds.' },
      { icon: 'sparkle', title: 'Grounds the AI', body: 'Reports and Sparks draw on your firm’s knowledge, not generic answers.' },
      { icon: 'shield', title: 'Consistent advice', body: 'Everyone works from the same approved, up-to-date source.' },
    ],
  },
  {
    slug: 'client-portal',
    name: 'Client Portal',
    tagline: 'Coming soon: a branded, always-on digital experience your clients will actually use.',
    icon: 'portal',
    colorClass: 'portal',
    pricingModules: ['client_portal'],
    featured: false,
    seo: {
      title: 'Branded Client Portal',
      description:
        'Give clients a secure, branded portal to see their wealth, documents and progress 24/7, turning the annual review into an ongoing relationship.',
      keywords: 'client portal financial advisers, branded adviser portal, secure client document sharing',
    },
    hero: {
      eyebrow: 'Coming soon: Client Portal',
      title: 'Annual review to',
      titleAccent: 'always-on',
      subtitle:
        'A secure, branded portal where clients see their wealth, documents and progress whenever they want, building engagement and loyalty between meetings.',
    },
    benefits: [
      { icon: 'portal', title: 'Always-on access', body: 'Clients see their wealth and documents 24/7, in your branding.' },
      { icon: 'document', title: 'Secure document sharing', body: 'Exchange documents safely, with a clear record of what was shared.' },
      { icon: 'users', title: 'Deeper engagement', body: 'Turn the once-a-year review into an ongoing conversation.' },
    ],
  },
]
